<template>
  <router-view></router-view>
</template>

<script>
import { mapGetters , mapState } from "vuex";
export default {
  name: "app",
  computed: {
    ...mapState("login", ["access_token"]),
    ...mapGetters("login", ["loggedIn"])
  },
  mounted() {
    var perm = [];

    if(this.access_token){
      let payload = JSON.parse(this.parseJwt(this.access_token));


      if(payload.scopes){
        payload.scopes.forEach((value, index) => {
          var obj = {};
          obj.actions = value;
          obj.subject = 'all';
          perm.push(obj);
        });
        this.$ability.update(perm);
      }
    }

  },
  methods:{
    parseJwt(token) {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));

      return jsonPayload;
    }
  }
};
</script>

<style lang="scss">
// CoreUI Icons Set
@import "~@coreui/icons/css/coreui-icons.min.css";
/* Import Font Awesome Icons Set */
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/scss/font-awesome.scss";
/* Import Simple Line Icons Set */
$simple-line-font-path: "~simple-line-icons/fonts/";
@import "~simple-line-icons/scss/simple-line-icons.scss";
/* Import Flag Icons Set */
@import "~flag-icon-css/css/flag-icon.min.css";
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
// Import Main styles for this application
@import "assets/scss/style";

.modal-header {
    border-bottom: 0px solid !important;
}

.modal-footer {
    border-top: 0px solid !important;
    display: none !important;
}

.app-header {
  /*box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.04) !important;*/
  border-bottom: 0px solid !important;
  background-color: #fff !important;
}

.app-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 0.7rem 1rem !important;
  color: #23282c;
  background: #fff0 !important;
  border-top: 0px solid !important;
}

.breadcrumb {
  background-color: #dcf3fd !important;
  border-bottom: 0px solid !important;
}



.wizard-header {
  display: none !important;
}

.vue-form-wizard.md .wizard-icon-circle.tab_shape {
  border-top-right-radius: 10px !important;
  border-top-left-radius: 10px !important;
}

.vue-form-wizard .wizard-icon-circle .wizard-icon-container.square_shape, .vue-form-wizard .wizard-icon-circle .wizard-icon-container.tab_shape {
  border-top-right-radius: 10px !important;
  border-top-left-radius: 10px !important;
}

.vue-form-wizard .wizard-icon-circle.tab_shape {
  min-width: 45px !important;
}

.vue-form-wizard .wizard-card-footer {
  padding: 0px !important;
}

.vue-form-wizard.md .wizard-navigation .wizard-progress-with-circle {
visibility: hidden;
}

.vue-form-wizard .wizard-nav>li {
  margin: 0 2px;
}

@media (max-width: 768px) {

  .vue-form-wizard .navbar .navbar-nav>li>a.wizard-btn, .vue-form-wizard .wizard-btn {
    min-width: 100px !important;
  }

  .vue-form-wizard .wizard-nav>li {
    margin: 0px;
  }

  .vue-form-wizard .wizard-tab-content {
    padding: 30px 0px 10px !important;
  }

  .required-msg{
    display: none;
  }

  .btn-info-action{
    width: 100%;
  }
  .btn-tabs{
    float: none !important;
    margin-bottom: 3px !important;
  }

  .wizard-footer-left{
    float: none !important;
  }

  .wizard-footer-right{
    float: none !important;
  }

  .wizard-btn{
    width: 100% !important;
    margin-bottom: 6px !important;
    padding: 12px !important;
  }

  .trnsfer-btn{
    width: 100% !important;
    margin-bottom: 3px !important;
  }

  .wizard-margin{
    margin-top: -28px !important;
  }

  .btn-info-action{
    padding: 12px;
  }

  .trnsfer-btn{
    padding: 12px;
  }

  .btn-block{
    padding: 12px;
  }

  .cover-data-table th, .cover-data-table td{
    padding: 5px;
  }

  .cover-name-slot{
    font-size: 12px;
  }

  .app-footer{
    display: none;
  }


}


</style>
